var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',[_c('th',{staticClass:"cf-c-data-card-table__th"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('td',{staticClass:"cf-c-data-card-table__td",class:_vm.textColorStyles},[_vm._v(" "+_vm._s(_vm.content)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }